module.exports = __webpack_public_path__ + "src/assets/img/comments.21321ea2.jpg";